import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pMicrosoft from '../../images/clients/buildlab_microsoft.svg'
import pAws from '../../images/clients/buildlab_aws.svg'
import pGoogle from '../../images/clients/buildlab_google.svg'
import pIbm from '../../images/clients/buildlab_ibm.svg'
import pSalesforce from '../../images/clients/buildlab_salesforce.svg'
import pAdobe from '../../images/clients/buildlab_adobe.png'
import pOpenai from '../../images/clients/buildlab_openai.svg'
import pAnthropic from '../../images/clients/buildlab_anthropic.svg'
import pCisco from '../../images/clients/buildlab_cisco.svg'
import pMeraki from '../../images/clients/buildlab_meraki.svg'
import pUbiquiti from '../../images/clients/buildlab_ubiquiti.svg'
import pFortinet from '../../images/clients/buildlab_fortinet.svg'
import pPaloalto from '../../images/clients/buildlab_paloalto.svg'

const partners = [
    { pImg: pMicrosoft, name: 'Microsoft' },
    { pImg: pAws, name: 'AWS' },
    { pImg: pGoogle, name: 'Google' },
    { pImg: pIbm, name: 'IBM' },
    { pImg: pSalesforce, name: 'Salesforce' },
    { pImg: pAdobe, name: 'Adobe' },
    { pImg: pOpenai, name: 'OpenAI' },
    { pImg: pAnthropic, name: 'Anthropic / Claude' },
    { pImg: pCisco, name: 'Cisco' },
    { pImg: pMeraki, name: 'Cisco Meraki' },
    { pImg: pUbiquiti, name: 'Ubiquiti / UniFi' },
    { pImg: pFortinet, name: 'Fortinet' },
    { pImg: pPaloalto, name: 'Palo Alto Networks' },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {

    return (
        <div className="client_logo_carousel">
            <Slider {...settings}>
                {partners.map((partner, pitem) => (
                    <div className="client_logo_item" key={pitem}>
                        <img src={partner.pImg} alt={partner.name} style={{ maxHeight: '48px', width: 'auto', objectFit: 'contain' }} />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default PartnerSection;
